/**
Project: Voice Panel (c)
Title: Home
Description: Component for displaying the home page
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Flex,
  Text,
  Segment,
  Image,
  Button,
  AcceptIcon,
  CloseIcon,
} from "@fluentui/react-northstar";
import { Grid, Row, Col } from "react-flexbox-grid";
import axios from "axios";
import PageUtil from "../../../../core/helpers/page-util";
import IntlUtil from "../../../../core/helpers/intl-util";
import VoiceCallingImage from "../../../../../assets/images/illustrations/voice_calling.png";
import { VoiceAdminURLProps } from "../settings/voice-admin-urls";
import { manageError } from "../../../../core/actions/common-actions";
import { hidePageWaitDialog } from "../actions/general-actions";
import { AppPageTitle } from "../../../../core/components/app-page-title";


class Home extends Component {
  _isMounted = false;
  _axiosSource = axios.CancelToken.source();
  _cancelToken = { cancelToken: this._axiosSource.token };
  _intl_ns_common = "common";
  _intl_ns_vpa_home = "vpa_home";

  setStateAsync = (state) => {
    if (this._isMounted) {
      return new Promise((resolve) => {
        this.setState(state, resolve);
      });
    }
  };

  async componentDidMount() {
    this._isMounted = true;
    PageUtil.scrollToTop();
    await this.loadPageData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this._axiosSource.cancel(
      IntlUtil.getText(
        this._intl_ns_common,
        "notification.warning.requestCancelled"
      )
    );
  }

  loadPageData = async () => {
    try {
      await this.props.hidePageWaitDialog();
    } catch (err) {
      await manageError(err, this.props.history);
    }
  };

  render() {
    return (
      <>
        <AppPageTitle
          pageTitle={IntlUtil.getText(this._intl_ns_vpa_home, "title.home")}
        />
        <Flex column className="page-wrapper">
          <Flex column className="page-content">
            <Grid fluid className="page-grid">
              <Row>
                <Col xs={12} sm={12} md={8} lg={9} className="m-b-20">
                  <Row>
                    <Col xs={12} className="m-b-10">
                      <Text className="page-heading1">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_home,
                          "content.welcome"
                        )}
                      </Text>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} className="m-b-10">
                      <Text className="page-text">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_home,
                          "content.sippioCaption"
                        )}
                      </Text>
                    </Col>
                  </Row>
                  <Row between="xs">
                    <Col xs={12} className="m-b-10">
                      <Text className="page-text">
                        {IntlUtil.getText(
                          this._intl_ns_vpa_home,
                          "content.sippioIntroduction"
                        )}
                      </Text>
                    </Col>
                  </Row>
                  <Row between="xs">
                    <Col xs={12} sm={8} md={6} lg={4} xl={3} className="m-t-20">
                      <Segment className="page-segment">
                        <Flex column gap="gap.medium">
                          <Text className="page-heading6">
                            {IntlUtil.getText(
                              this._intl_ns_vpa_home,
                              "content.setUpCalling"
                            )}
                          </Text>
                          {this.props.subscriberAccount?.voiceSetupStatus ===
                          true ? (
                            <>
                              <Flex gap="gap.small">
                                <AcceptIcon circular />
                                <Text className="page-text">
                                  {IntlUtil.getText(
                                    this._intl_ns_vpa_home,
                                    "content.completed"
                                  )}
                                </Text>
                              </Flex>
                            </>
                          ) : (
                            <>
                              <Flex gap="gap.small">
                                <CloseIcon circular />
                                <Text className="page-text">
                                  {IntlUtil.getText(
                                    this._intl_ns_vpa_home,
                                    "content.notCompleted"
                                  )}
                                </Text>
                              </Flex>
                              <Flex gap="gap.small">
                                <Button
                                  primary
                                  onClick={() => {
                                    this.props.history.push(
                                      VoiceAdminURLProps.setup
                                    );
                                  }}
                                >
                                  <Text size="medium">
                                    {IntlUtil.getText(
                                      this._intl_ns_vpa_home,
                                      "content.setupNow"
                                    )}
                                  </Text>
                                </Button>
                              </Flex>
                            </>
                          )}
                        </Flex>
                      </Segment>
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} sm={12} md={4} lg={3} className="m-b-10">
                  <Image
                    src={VoiceCallingImage}
                    alt=""
                    className="vpa-home-page-image"
                  />
                </Col>
              </Row>
            </Grid>
          </Flex>
        </Flex>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  subscriberAccount: state.subscriberStore.subscriberAccount,
});

const mapActionToProps = { hidePageWaitDialog };

export default connect(mapStateToProps, mapActionToProps)(Home);
